import { useState } from 'react';
import { useVantifyContext } from 'integrations-vantify-context-providers';
import {
  getSubJobGroups,
  SubJobGroup,
} from 'integrations-vantify-client-services';
import { FetchSubCategoriesParams } from './types';
import { useVantifyBase } from '../useVantifyBase';
import { VantifyOperation, hookMessages } from '../common';

export function useVantifySubCategories() {
  const { auth } = useVantifyContext();
  const { loading, error, execute, setError } = useVantifyBase();
  const [subCategories, setSubCategories] = useState<SubJobGroup[] | null>(
    null
  );

  const fetchSubCategories = async ({
    jobGroupId,
  }: FetchSubCategoriesParams) => {
    if (!auth) {
      setError((e) => ({
        ...e,
        [VantifyOperation.FETCH_SUBCATEGORIES]:
          hookMessages.error_FETCH_SUBCATEGORIES,
      }));

      return null;
    }

    const response = await execute(
      VantifyOperation.FETCH_SUBCATEGORIES,
      () => getSubJobGroups(auth, jobGroupId),
      hookMessages.error_FETCH_SUBCATEGORIES
    );

    if (response?.data?.jobgroups) {
      setSubCategories(response.data.jobgroups);

      return response.data.jobgroups;
    }

    return null;
  };

  return {
    subCategories,
    loading,
    error,
    fetchSubCategories,
  };
}

